export default __webpack_public_path__ + "static/Resume_Michals-5b738489b2fd37dd2a23835240852388.pdf";